import React, { useEffect } from "react";
import { MDBDataTableV5 } from "mdbreact";
import { allDebtors } from "../../../utils/data";
import { Button, TableContainer } from "../../../styles";
import { ICON_BIN, ICON_PEN, ICON_PLUS } from "../../../utils/icons";
import DeleteModal from "../DeleteModal";
import { useState } from "react";
import AddDebtor from "./AddDebtor";
import EditDebtor from "./EditDebtor";
import { useDebtContext } from "../../../context/debt_context";
import { useUserContext } from "../../../context/user_context";
import MiniLoader from "../../../utils/MIniLoader";
import CustomTable from "../../../utils/CustomTable";

export default function AllDebtors() {

      const [debtorData, setDebtorData] = useState('');


      const { btoken, stoken } = useUserContext();

      const {
            openAddDebtor,
            openEditDebtor,
            debtLoading, getDebtData, allDebts
      } = useDebtContext();

      function openEditModal(item) {
            setDebtorData(item);
            openEditDebtor();
      }


      useEffect(() => {
            const debtor = allDebts?.debtor?.map((item, i) => {

                  const { id, name, phone, mail, amount_th, real_due_date, real_date } = item;

                  const payload = { did: id, btoken, stoken };

                  return (
                        {
                              sn: i + 1,

                              id,

                              name,

                              phone,

                              mail,

                              amount_th,

                              real_due_date,

                              real_date,

                              action:
                                    <h6 className="d-flex fit-content  border-bottom pointer border-success green-text text-center"
                                          onClick={() => openEditModal(item)}
                                    >
                                          {ICON_PEN}
                                    </h6>
                              ,
                              delete:
                                    <DeleteModal
                                          payload={payload}
                                          name={name}
                                          url={'deleteDebt'}
                                          getDataFn={getDebtData}
                                          dataName={'Debtor'}
                                    >
                                          <h6 className="d-flex fit-content  border-bottom pointer border-danger red-text text-center"
                                          >
                                                {ICON_BIN}
                                          </h6>
                                    </DeleteModal>
                        }
                  );
            });

            setDatatable({
                  ...datatable,
                  rows:
                        debtor
            });
      }, [allDebts]);

      useEffect(() => {
            getDebtData();
      }, []);


      const [datatable, setDatatable] = React.useState({
            columns: [
                  {
                        label: "S/N",
                        field: "sn",
                        width: 150,
                  },
                  {
                        label: "ID",
                        field: "id",
                        width: 150,
                  },
                  {
                        label: "Date Added",
                        field: "real_date",
                        width: 200,
                  },
                  {
                        label: "Name",
                        field: "name",
                        width: 270,
                  },
                  {
                        label: "Phone",
                        field: "phone",
                        width: 270,
                  },
                  {
                        label: "Email",
                        field: "mail",
                        width: 270,
                  },
                  {
                        label: "Amount",
                        field: "amount_th",
                        width: 270,
                  },
                  {
                        label: "Amount",
                        field: "real_due_date",
                        width: 270,
                  },
                  {

                        label: 'Action',
                        field: "action",
                        width: 200,
                  },
                  {
                        label: 'Delete',
                        field: "delete",
                        width: 200,
                  },
            ],
            rows: []
      });


      return (
            <>
                  <div className="">

                        <CustomTable
                              tableTitle={"All Debtor"}
                              loading={debtLoading}
                              getData={getDebtData}
                              openAddModal={openAddDebtor}
                              addTitle={"Add Debtor"}
                              datatable={datatable}
                        />

                  </div>

                  {/* Add Debtor Modal */}
                  <AddDebtor />
                  {/* Add Debtor Modal */}

                  {/* Edit Debtor Modal */}
                  <EditDebtor
                        {...debtorData}
                  />
                  {/* Edit Debtor Modal */}
            </>

      );
}
